import React, { useContext, useState, useEffect } from 'react'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import { Button } from '@material-ui/core'
import * as Yup from 'yup'
import CommonFront from '@/custom/context/frontCommon/settingContext'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import CommonContext from '@/product/context/common/commonContext'
import { handleRedirectInternal, mapData, useCustomMediaQuery } from '@/product/common/components'
export const GetInTouch = ({ theme }) => {
    const commonFront = useContext(CommonFront)
    const commonContext = useContext(CommonContext)
    const { loaderSet } = commonContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        responseStatus: responseStatusUser,

        searchTableActionCBR,
        clearResponse: clearResponseCard,
    } = commonFront

    const formik = useFormik({
        initialValues: {
            id: 0,
            status: 1,
            request_from: 'All Brands',
            page: window.location.href,
            first_name: '',
            email_address: '',
            contact_number: '',
            address: '',
        },
        validationSchema: Yup.object({
            first_name: Yup.string()
                .matches(/^[a-zA-Z ."'\-]*$/g, 'No Special Characters and Numbers Allowed')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),

            contact_number: Yup.string().required('Mobile Number is required'),
            email_address: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            address: Yup.string(),
        }),
        onSubmit: (values) => {
            loaderSet(true)
            searchTableActionCBR(values, false, 'searchTableActionCBR2')
        },
    })
    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from == 'searchTableActionCBR2') {
                loaderSet(false)
                if (responseStatusUser.status === 'success') {
                    formik.resetForm()
                    formik.handleReset()
                }
                setAlert(responseStatusUser.message, responseStatusUser.status || 'error')
            }

            clearResponseCard()
        }
    }, [responseStatusUser])
    const callbackFormFields = [
        {
            label: 'Name',
            placeholder: 'Enter your name',
            type: 'text',
            upperLabel: true,
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'first_name',
        },

        {
            label: 'Mobile',
            placeholder: 'Mobile Number',
            type: 'phone',
            upperLabel: true,
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'contact_number',
            required: true,
        },
        {
            label: 'Email Address',
            placeholder: 'Email Address',
            upperLabel: true,
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'email_address',
        },
        {
            label: 'Address',
            upperLabel: true,
            placeholder: 'Address',
            type: 'text',
            class: 'col-md-6 col-12 changeInputHeight',
            name: 'address',
        },
    ]
    const inputProps = [
        {
            name: 'fullName',
            label: 'Full Name',
            placeholder: 'Full Name',
            type: 'text',
        },
        {
            name: 'email',
            label: 'Email ID',
            placeholder: 'Email',
            type: 'email',
        },
        {
            name: 'mobileNumber',
            label: 'Mobile Number *',
            placeholder: 'Mobile Number',
            type: 'tel',
        },
        {
            name: 'location',
            label: 'Location',
            placeholder: 'Location',
            type: 'text',
        },
    ]
    return (
        <div className="sectionContainer customContainer">
            <form
                className="getInTouchForm"
                style={{ borderColor: theme?.bgColor }}
                onSubmit={formik.handleSubmit}
            >
                <h3 className="getInTouchHeading">Get in touch</h3>
                <div className="getInTouchRow">
                    {/* {inputProps.map((input, index) => (
                        <div className="getInTouchCol" key={index}>
                            <div className="getInTouchInput">
                                <CustomInput
                                    name={input.name}
                                    label={input.label}
                                    placeholder={input.placeholder}
                                    type={input.type}
                                    upperLabel={true}
                                    value={formik.values[input.name]}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched[input.name] && formik.errors[input.name]}
                                />
                            </div>
                        </div>
                    ))} */}
                    <div className="row formContainer p-0 m-0 w-100">
                        {mapData({ data: callbackFormFields, formik })}
                    </div>
                    <div className="getInTouchCol getInTouchColFull mt-4">
                        <Button
                            type="submit"
                            style={{
                                background: theme?.bgColor,
                                borderColor: theme?.bgColor,
                                height: '40px',
                                color: 'white',
                            }}
                            className="getInTouchSubmit"
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    )
}
